import "./index.scss"

import React, { Component } from "react"
import { Link } from 'react-router-dom'

import T from "prop-types"
import BEMHelper from "react-bem-helper"

const bem = new BEMHelper("dropdown")

const ANIMATE_OUT_DURATION = 100
const KEY_ESC = 27

export default class Dropdown extends Component {
  static propTypes = {
    options: T.array,
    subtle: T.bool,
    xsmall: T.bool,
    small: T.bool,
    large: T.bool,
    xlarge: T.bool,
    center: T.bool,
    left: T.bool,
    link: T.bool,
    fullWidth: T.bool,
    menu: T.bool,
    className: T.string,
    trigger: T.string,
    icon: T.bool,
    children: T.any,
    active: T.bool,
    inline: T.bool,
    noClose: T.bool,
    title: T.string,
  }

  state = {
    expanded: false,
    animateOut: false,
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown)
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown)
    clearTimeout(this._animationTimer)
  }

  _animationTimer = null

  toggle = value => () => {
    const expanded = !value && value !== false ? !this.state.expanded : value
    const animateOut = !expanded

    this.setState({ expanded, animateOut }, this.animateOut(animateOut))
  }

  animateOut = value => () => {
    if (value) {
      clearTimeout(this._animationTimer)

      this._animationTimer = setTimeout(() => {
        this.setState({ animateOut: false })

        if (this._trigger) {
          this._trigger.focus()
        }
      }, ANIMATE_OUT_DURATION)
    }
  }

  handleKeyDown = ({ keyCode }) => {
    if (keyCode === KEY_ESC && this.state.expanded) {
      this.toggle(false)()
    }
  }

  render() {
    const { expanded, animateOut } = this.state
    const {
      options,
      trigger,
      className,
      subtle,
      xsmall,
      small,
      large,
      xlarge,
      center,
      left,
      fullWidth,
      menu,
      inline,
      link,
      removable,
      icon,
      children,
      active,
      noClose,
      title,
    } = this.props

    const selectedOption = options && options.filter(option => option.selected === true)
    const triggerLabel = selectedOption && selectedOption.length > 0 ? selectedOption[0].label : trigger

    return (
      <span
        {...bem(
          "",
          {
            expanded: expanded || animateOut,
            "animate-out": animateOut,
            subtle,
            xsmall,
            small,
            large,
            xlarge,
            center,
            left,
            icon,
            menu,
            link,
            inline,
            removable,
            active,
            "no-close": noClose,
            fullWidth,
          },
          className
        )}
      >


        <button
          type="button"
          {...bem("trigger", { expanded: expanded || animateOut })}
          onClick={this.toggle()}
          aria-expanded={expanded}
        >

          {trigger &&
            <>
              <span {...bem("label")}>{triggerLabel}</span>
              <span {...bem("icon")}>
                <svg viewBox="0 0 36 20">
                  <path d="M34 2.00025L22.3707 15.9686C20 18.5 16.5 18.5 14.0873 16.0228L2 2" />
                </svg>
              </span>
            </>
          }

          {menu &&
            <span {...bem("menu")}>
              <svg viewBox="0 0 38 8">
                <circle cx="4" cy="4" r="4" />
                <circle cx="19" cy="4" r="4" />
                <circle cx="34" cy="4" r="4" />
              </svg>
            </span>
          }
        </button>

        {(expanded || animateOut) && (
          <div {...bem("content")} onClick={options && this.toggle(false)}>
            <div {...bem("options")}>
              {options && (
                <>
                  {options
                    .filter(({ show }) => show !== false)
                    .map(({ label, show, to, selected, removable, ...props }, index) =>
                      to ? (
                        <Link key={index} to={to} {...bem("option", { selected })} {...props}>
                          {label}
                        </Link>
                      ) : (
                        <button
                          type="button"
                          key={index}
                          to={to}
                          disabled={selected || false}
                          {...bem("option", { selected })}
                          {...props}
                        >
                          {label}
                          {removable &&
                            <button type="button" {...bem("trash")}>
                              <svg viewBox="0 0 22 26.4">
                                <polyline points="0,6 2.4,6 22,6 "/>
                                <path d="M19.6,6v16.8c0,1.3-1.1,2.4-2.4,2.4H4.9c-1.4,0-2.4-1.1-2.4-2.4V6 M6.1,6V3.6c0-1.3,1.1-2.4,2.4-2.4h4.9
                                	c1.4,0,2.4,1.1,2.4,2.4V6"/>
                                <line x1="8.6" y1="12" x2="8.6" y2="19.2"/>
                                <line x1="13.4" y1="12" x2="13.4" y2="19.2"/>
                              </svg>
                            </button>
                            }
                        </button>
                      )
                    )}
                </>
              )}

              {!options && children && (
                <>
                  {noClose ? (
                    null
                  ):(
                    <button
                      {...bem("content-close")}
                      type="button"
                      onFocus={this.toggle(false)}
                      onClick={this.toggle(false)}
                      aria-label="Lukk"
                    >
                      Close
                    </button>
                  )}
                  {title && <h4 {...bem("content-title")}>{title}</h4>}
                  {children}
                </>
              )}
            </div>
          </div>
        )}

        {(expanded || animateOut) && (
          <button
            {...bem("backdrop")}
            type="button"
            onFocus={this.toggle(false)}
            onClick={this.toggle(false)}
            aria-label="Lukk"
          />
        )}
      </span>
    )
  }
}
